import React, {useState} from "react";
import {Button, Popover} from "antd";
import {FiAlertCircle} from "react-icons/fi";

export const priorities = [
    {id: 3, name: 'Critical', color: 'rgb(153, 27, 27)', bgColor: '#333333'},
    {id: 2, name: 'High', color: 'rgb(153, 27, 27)', bgColor: '#401792'},
    {id: 1, name: 'Medium', color: 'rgb(234, 88, 12)', bgColor: '#5559dc'},
    {id: 0, name: 'Low', color: 'rgb(22, 101, 52)', bgColor: '#569af9'}
];

export const getPriorityById = (priorityId) => {
    return priorities.find(p => p.id === priorityId) || priorities[2];
};


export const PriorityDropdown = ({onUpdateTask, task}) => {
    const [open, setOpen] = useState(false);

    const handlePriorityChange = (priorityId) => {
        onUpdateTask(task.id, {priority: priorityId});
        setOpen(false);
    };

    return (
        <Popover
            open={open}
            onOpenChange={setOpen}
            trigger={["click"]}
            content={
                <div className="max-w-32">
                    {priorities.map((priority, i) => (
                        <Button
                            className={`text-white inline-flex w-full justify-between items-center text-xs font-normal mb-1 px-2`}
                            style={{backgroundColor: priority.bgColor}}
                            block
                            key={i}
                            onClick={() => handlePriorityChange(priority.id)}
                        >
                            <span className="flex items-center gap-2">
                                <FiAlertCircle className="h-3.5 w-3.5"/>
                                {priority.name}
                            </span>
                            {task.priority === priority.id && (
                                <span className="ml-2">✓</span>
                            )}
                        </Button>
                    ))}
                </div>
            }
            title={null}
        >
            <Button
                block
                className={`text-white inline-flex w-full h-full justify-center items-center text-[13px] font-normal`}
                style={{backgroundColor: getPriorityById(task.priority).bgColor}}
            >
                {getPriorityById(task.priority).name}
            </Button>
        </Popover>
    );
};
